module.exports = __webpack_public_path__ + "static/media/brand-library-assets-empty.918149cd.svg";